import { iFBCallLog } from "@sdk/fb-call-logs/fb-call-logs-model";
import _ from "lodash";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";
import {
  generateFBCallLogOfContactQuery,
  generateFBCallLogOfRingAgentQuery,
} from "./fb-call-logs.helpers";

export const {
  selectQueryMap: selectFBCallLogQueryMap,
  selectEntityMap: selectFBCallLogsMap,
  selectQueryMapAll: selectFBCallLogsMapAll,
  selectQueryAllList: selectFBCallLogsAllList,
  selectAllEntities: selectAllFBCallLogs,
  selectAllEntitiesQuery: selectAllFBCallLogsQuery,
  selectEntityById: selectFBCallLogById,
  selectEntityQuery: selectFBCallLogQuery,
  selectEntityQueryList: selectFBCallLogQueryList,
} = CreateSelectorForEntities<iStore, iFBCallLog>({
  sliceName: "FBCallLogs",
});

export const selectFBCallLogByConnectionId =
  (connectionId: string) => (state: iStore) => {
    return _.find(selectAllFBCallLogs(state), {
      connectionId,
    });
  };

export const selectFBCallLogsByContactId = (contactId: string) => {
  return selectFBCallLogQuery(
    JSON.stringify(generateFBCallLogOfContactQuery(contactId)),
  );
};

export const selectFBCallLogsByRingAgentId = (ringAgentId: string) => {
  return selectFBCallLogQuery(
    JSON.stringify(generateFBCallLogOfRingAgentQuery(ringAgentId)),
  );
};
